import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.checkInsSlice || initialState;

export const selectCheckIns = createSelector([selectSlice], state => state);

export const selectBatches = createSelector(
  [selectSlice],
  state => state.batches,
);

export const selectEligibleCount = createSelector(
  [selectSlice],
  state => state.eligibleCount,
);

export const selectSendBatch = createSelector(
  [selectSlice],
  state => state.sendBatch,
);
